export default {
  submembers: [],
  totalDocs: 0,
  totalPages: 0,
  page: 1,
  totalSubmembers: 0,
  loading: false,
  error: null,
}
